/* eslint-disable no-var */
import Vue from 'vue'

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toLowerCase()
  value = value.toString()
  const arr = value.split(' ')
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('uppercase', function (value) {
  return value.toUpperCase()
})

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('truncate', function (value, limit) {
  return value.substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
  return value + tail
})

Vue.filter('time', function (value, is24HrFormat = false) {
  if (value) {
    const date = new Date(Date.parse(value))
    let hours = date.getHours()
    const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
    if (!is24HrFormat) {
      const time = hours > 12 ? 'AM' : 'PM'
      hours = hours % 12 || 12
      return `${hours  }:${  min  } ${  time}`
    }
    return `${hours  }:${  min}`
  }
})

Vue.filter('date', function (value, fullDate = false) {
  value = String(value)
  const date = value.slice(8, 10).trim()
  const month = value.slice(4, 7).trim()
  const year = value.slice(11, 15)

  if (!fullDate) return `${date  }${  month}`
  else return `${date  }${  month  }${  year}`
})

Vue.filter('date2', function (value) {
  value = String(value)
  // console.log('value: ', value)
  const date = value.slice(8, 10).trim()
  const month = value.slice(5, 7).trim()
  const year = value.slice(0, 4)
  // console.log('date: ', date)
  // console.log('month: ', month)
  // console.log('year: ', year)
  
  return `${date  }-${  month}-${year}`
})

Vue.filter('month', function (val, showYear = true) {
  val = String(val)

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./
  if (!showYear) {
    return regx.exec(val)[1]
  } else {
    return `${regx.exec(val)[1]  } ${  regx.exec(val)[2]}`
  }

})

Vue.filter('month2', function (val) {
  const month_names_short = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  return `${month_names_short[val.getMonth()]} ${val.getFullYear()}`
})

Vue.filter('csv', function (value) {
  return value.join(', ')
})

Vue.filter('filter_tags', function (value) {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
})

Vue.filter('k_formatter', function (num) {
  return num > 999 ? `${(num / 1000).toFixed(1)  }k` : num
})

Vue.filter('formato_fecha', function (date) {
  //Guardo en variable la fecha registrada en la BD, que está en UTC por configuración de Laravel
  const fechaBD = new Date(date)
  //Guardo la fecha actual del navegador del cliente
  const fecha_actual_navegador = new Date()
	
  // Calculo la diferencia en minutos de la fecha_actual_navegador con respecto a UTC, bueno en milisegundos (*60*1000)
  const difMinutosDesdeFechaNavegador = fecha_actual_navegador.getTimezoneOffset() * 60 * 1000
	
  // Condicional si el cliente tiene fecha_actual_navegador mayor o menor a la fecha UTC grabada en BD, establecerá una diferencia (siempre positiva) sumando o restando la diferencia a la fecha del registro en BD
  // eslint-disable-next-line no-var
  if (difMinutosDesdeFechaNavegador > 0) var diferencia = fechaBD.getTime() - difMinutosDesdeFechaNavegador
  // eslint-disable-next-line no-redeclare
  else if (difMinutosDesdeFechaNavegador < 0) var diferencia = fechaBD.getTime() + difMinutosDesdeFechaNavegador
	
  //Convierta a fecha la variable 'diferencia' que está en milisegundos.
  const fecha_Adaptada = new Date(diferencia)
  const options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
  //Retorna la fecha adaptada, en conjunto con las opciones toLocaleDateString.
  return fecha_Adaptada.toLocaleDateString('es-ES', options)
})

Vue.filter('formato_fecha2', function (date) {
  if (date === null) return
  //Guardo en variable la fecha registrada en la BD, que está en UTC por configuración de Laravel
  const fechaBD = new Date(date)
  const options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
  //Retorna la fecha adaptada, en conjunto con las opciones toLocaleDateString.
  return fechaBD.toLocaleDateString('es-ES', options)
})

Vue.filter('formato_fecha3', function (date) {
  if (date === null) return
  const fechaBD3 = new Date(date)
  return `${fechaBD3.getUTCDate()}-${fechaBD3.getUTCMonth() + 1}-${fechaBD3.getUTCFullYear()}`
})

Vue.filter('formato_timer', function (date) {
  const fecha_actual_navegador = new Date()
  // console.log("Fecha actual del navegador:", fecha_actual_navegador)
  // eslint-disable-next-line no-mixed-operators
  const fecha_actual_navegador_UTC_miliseconds = (fecha_actual_navegador.getTime() + fecha_actual_navegador.getTimezoneOffset() * 60 * 1000)
  // console.log("fecha actual navegador en UTC:", fecha_actual_navegador_UTC_miliseconds)
  const fecha_actualizacion = new Date(date)
  // console.log("Fecha de la actualización:", fecha_actualizacion)
  const diferencia_entre_tiempo = fecha_actualizacion.getTime() - fecha_actual_navegador_UTC_miliseconds
  // console.log("diferencia entre tiempos ", diferencia_entre_tiempo)
  const timer_dias = ((diferencia_entre_tiempo) / 1000) / 86400
  // console.log("Tiempo en días", timer_dias)
  const dias_redondeo = Math.floor(timer_dias)
  // console.log("Días sin redondeo", dias_redondeo)
  const timer_semanas = timer_dias / 7
  // console.log("Tiempo en semanas", timer_semanas)
  const semanas_redondeo = Math.floor(timer_semanas)
  // console.log("Semanas sin redondeo", semanas_redondeo)
  //Returns del timer Cuando la cita es en el futuro
  if (timer_dias <= 0.04166667 && timer_dias >= 0) return `en ${  ((diferencia_entre_tiempo / 1000) / 60).toFixed(0)  } min`
  if (timer_dias <= 1 && timer_dias > 0.04166667) return `en ${  (timer_dias * 24).toFixed(0)  } h`
  if (timer_dias > 1 && timer_dias <= 30) return `en ${  dias_redondeo.toFixed(0)  } d`
  if (timer_dias > 30) return `en ${  semanas_redondeo.toFixed(0)  } sem`
  //Returns del timer cuando la cita ya se realizó (está en el pasado)
  if (timer_dias < 0 && timer_dias >= -0.04166667) return `hace ${  ((diferencia_entre_tiempo / 1000) / 60).toFixed(0) * -1  } min`
  if (timer_dias < -0.04166667 && timer_dias >= -1) return `hace ${  (timer_dias * 24).toFixed(0) * -1  } h`
  if (timer_dias < -1 && timer_dias >= -30) return `hace ${  dias_redondeo.toFixed(0) * -1  } d`
  if (timer_dias < -30) return `hace ${  semanas_redondeo.toFixed(0) * -1  } sem`
  return dias_redondeo
})

Vue.filter('formato_fecha_de_nacimiento', function (date) {
  //OBTENGO LA FECHA DEL CALENDARIO
  const birthdateDate = new Date(date)
  // console.log("fecha traida del backend en tabla families", birthdateDate)
  //Extraigo el Año de la fecha
  const dateYear = birthdateDate.getUTCFullYear()
  // console.log("año: ", dateYear)
  //Extraigo el mes. Le sumo uno, porque JS considera mes Enero como 0, y no como 1. Pequeña carpintenria para que almacene correctamente.
  const mesAnio = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
  const dateMonth = birthdateDate.getUTCMonth()
  // console.log("mes: ", birthdateDate.getUTCMonth())
  // console.log("mes: ", mesAnio[dateMonth])
  //Extraigo el día de la fecha del calendario
  const dateDay = birthdateDate.getUTCDate()
  // console.log("dia: ", dateDay)
  // console.log(dateDay +" "+ mesAnio[dateMonth] +" "+ dateYear)
  return `${dateDay } ${ mesAnio[dateMonth] } ${ dateYear}`
})

Vue.filter('formatoMiles', function (num) {
  if (num === null || num === undefined) return
  //para miles sólo con punto
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  //para miles con punto y coma
  // let val = (value/1).toFixed(2).replace('.', ',')
  // return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
})

Vue.filter('showYesNo', function (value) {
  if (value === 0) return 'No'
  if (value === 1) return 'Si'

})

Vue.filter('financial_analysys_corrected', function (value) {
  if (value === -1) return 'Infinitos'
  return value

})


Vue.filter('formatoJobSalary', function (num) {
  if (num === null) return
  const numStr = num.toString()
  let [integerPart, decimalPart] = numStr.split(/([,.])(?=\d{2}$)/)
  decimalPart = ''
  integerPart = integerPart.replace(/[,.]/g, '') + decimalPart

  // Maybe ill fuck up but screw it - Convert to Annual 
  if (integerPart < 7000) {
    integerPart *= 12
    integerPart += ''
  }

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return integerPart
})